var React = require('react');

function ChartBar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 15L15 15M10.0001 15V6H13.143C13.6161 6 14.0001 6.336 14.0001 6.75L14.0001 15H10.0001ZM10.0001 15V1.77778C10.0001 1.34844 9.61612 1 9.14302 1L6.85718 1C6.38407 1 6.0001 1.34844 6.0001 1.77778L6.0001 15M10.0001 15H6.0001M6.0001 15V3L2.85718 3C2.38407 3 2.0001 3.3584 2.0001 3.8L2.0001 15H6.0001Z","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChartBar.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ChartBar;

ChartBar.default = ChartBar;
